
import homePages from '../Images/affiliate.jpg';

const AffiliateProgram = () => {
  return (
    <div className="affiliate-program">
      <header className="affiliate-header">
        <h1>Become a PlusCredit Affiliate</h1>
        <p>Join our growing network of affiliates and start earning by promoting trusted financial products and services to people who need them.</p>
        <img src={homePages} alt="hero" className="affilatehero" />
      </header>

      <section className="who-are-affiliates">
        <h2>Who Are PlusCredit Affiliates?</h2>
        <p>Affiliates are individuals or agents who promote PlusCredit’s products and services to customers, both online and offline. They help connect users with financial solutions while earning commission for every successful referral or transaction.</p>
      </section>

      <section className="products">
        <h2>What Products Can Affiliates Promote?</h2>
        <div className="product-list">
          <div className="product-card">
            <h3>Smartphones on Installment</h3>
            <p>Offer Samsung phones with no upfront payment through SmartPay, powered by PlusCredit in partnership with Watu.</p>
          </div>
          <div className="product-card">
            <h3>BankVole App</h3>
            <p>Promote savings, investment plans, and bill payments. Earn commissions for app downloads and referral milestones.</p>
          </div>
          <div className="product-card">
            <h3>TravelMoni</h3>
            <p>Help customers access Proof of Funds (POF) for visa applications, study abroad, or international travel.</p>
          </div>
          <div className="product-card">
            <h3>Many More Coming Soon</h3>
            <p>Exciting products will be added soon, stay tuned!</p>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <h2>How Does It Work?</h2>
        <ol>
          <li>Sign up via the affiliate application form.</li>
          <li>Get trained and onboarded with product knowledge, marketing materials, and a referral code.</li>
          <li>Promote PlusCredit products to your network using social media, word of mouth, or direct outreach.</li>
          <li>Earn commission for every successful transaction or referral based on our payout structure.</li>
        </ol>
      </section>

      <section className="who-is-it-for">
        <h2>Who Is It For?</h2>
        <ul>
          <li>Students</li>
          <li>Agents</li>
          <li>Micro-influencers</li>
          <li>Digital marketers</li>
          <li>Hustlers looking for extra income</li>
          <li>Anyone with a network of people needing phones, savings, or travel support</li>
        </ul>
      </section>

      <section className="why-join">
        <h2>Why Join?</h2>
        <ul>
          <li>Zero capital needed</li>
          <li>Earn from home or on the go</li>
          <li>Weekly payouts</li>
          <li>Access to marketing support and product training</li>
          <li>Opportunity to grow with us</li>
        </ul>
      </section>

      <section className="cta">
        <h2>Ready to Get Started?</h2>
        <p>Click below to fill out the affiliate application form. Successful applicants will receive onboarding instructions and access to our affiliate toolkit.</p>
        <a href="https://forms.gle/YNjtSbt2QsecvnGy9" className="cta-button">Join the Affiliate Program</a>
      </section>
    </div>
  );
};

export default AffiliateProgram;
